import { gql } from "@apollo/client";
import { KeyNumber } from "@App/types";

export interface KeyNumberQuery {
  keyNumber: KeyNumber;
}

export const GET_KEY_NUMBER = gql`
    query getVehicle($hsn: String!, $tsn: String!) {
        keyNumber(hsn: $hsn, tsn: $tsn) {
            id
            name
            brand{
                id
                name
                logo
                slug
                important
            }
            generation {
                id
                name
                slug
                built_from
            }
            motorization {
                id
                name
                slug
                built_from
                built_to
                kw
                ps
                displacement
                bodies {
                    id
                    name
                }
                fuelType {
                    id
                    name
                }
                gearboxes {
                    id
                    name
                    formatted_name
                }
            }
        }
    }
`;
